import Layout from '@/container/Full'

const RenewView = () => import(/* webpackChunkName: "renew" */ '../views/renew/RenewView')
const RenewInvoiceView = () => import(/* webpackChunkName: "renew" */ '../views/renew/RenewInvoiceView')

const routes = [
  {
    path: '/renew',
    component: Layout,
    meta: {
      breadcrumb: 'Renewals',
      pageTitle: 'Renewal Options',
      access_type: 'authorized',
    },
    children: [
      {
        path: '',
        name: 'renew_list',
        component: RenewView,
        meta: {
          access_type: 'authorized',
          pageTitle: 'Renewal Options',
        },
      },
      {
        path: ':invoiceid',
        name: 'renew_invoice',
        component: RenewInvoiceView,
        props: true,
        meta: {
          access_type: 'authorized',
          pageTitle: 'Renewal Options',
        },
      },
    ],
  },
]

export default routes
